import type { Data } from '@repo/strapi-types'
import type { ComponentType, SVGProps } from 'react'
import { CheckMark } from '@/components/icons/CheckMark'
import { InfinityIcon } from '@/components/icons/Infinity'
import { Protect } from '@/components/icons/Protect'
import { Sparkle } from '@/components/icons/Sparkle'
import { Styleguide } from '@/components/icons/Styleguide'
import { Support } from '@/components/icons/Support'
import { Team } from '@/components/icons/Team'
import { Version } from '@/components/icons/Version'
import { Workflow } from '@/components/icons/Workflow'
import { cn } from '@/lib/styles'

const iconMap: Record<
	NonNullable<Data.Component<'shared.pricing-plan-highlight'>['icon']>,
	ComponentType<SVGProps<SVGSVGElement>>
> = {
	checkmark: CheckMark,
	sparkle: Sparkle,
	infinity: InfinityIcon,
	support: Support,
	styleguide: Styleguide,
	team: Team,
	version: Version,
	workflow: Workflow,
	protect: Protect,
}

export function HighlightIcon({
	icon,
	className,
}: {
	icon?: Data.Component<'shared.pricing-plan-highlight'>['icon'] | null
	yearly?: boolean
	className?: string
}) {
	const Icon = icon && iconMap[icon] ? iconMap[icon] : CheckMark
	return (
		<Icon
			aria-hidden
			className={cn(
				'size-5 top-0.5 relative shrink-0 mr-2',
				icon !== 'sparkle' && 'text-peach-500',
				className,
			)}
		/>
	)
}
